import React, { useState } from 'react';
import Location from '../../../components/Profile/Location/';
import CardProfile from '../../../components/Profile/Card/';

//import AboutForm from './Forms';
import { Formik } from 'formik';
import { validationContactInfoAbout } from '../../../utils/validations';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import AuthButton from '../../../components/Buttons/AuthButton';
import ButtonAction from '../../../components/Buttons/ButtonAction';
import OptionsButton from '../../../components/Buttons/OptionsButton';
import AddSite from '../../../components/Profile/AddSite';

import { makeStyles } from '@material-ui/styles';
import './Site.scss';

import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { connect } from 'react-redux';
import EditSite from '../../../components/Profile/AddSite/EditSite';
import TrophieModal from '../../../components/Modal/TrophieModal';
import { openModalFree } from '../../../store/actions/ModalFree';

var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;
var ElementScroll = Scroll.Element;

const useStyles = makeStyles({
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
  expandButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
});

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    borderRadius: 4,
    marginTop: 20,
    //display: 'grid',
    '&::before': {
      height: 0
    }
  },

})(MuiExpansionPanel);



const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 24,
    position: 'relative',
  },
  content: {
    margin: 0,
    width: '100%',
    flexFlow: 'column',
    alignItems: 'flex-start',
    padding: 0,
    cursor: 'auto',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#013957',
  },


  expanded: {
    display: 'none'
    //margin:0
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding: 24,
    //display: 'block',
    border: '1px solid #e7e7e7',
    borderRadius: 4,
    '@media (max-width: 600px)': {
      padding: '24px 8px 24px',
    }
  },
})(MuiExpansionPanelDetails);


const Site = (props) => {

  const { role, sede, authClient, trophie, membershipType, openModalFree } = props;
  const [ openTrophieModal, setOpenTrophieModal ] = useState(false);

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
  };

  const changeStatus = isActive => {

    setExpanded(isActive ? true : false)

  }

  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event) => {
    // if (membershipType === 'Free') {
    //   openModalFree(true, membershipType, role)
    // } else {
    //   setExpanded(expanded ? false : true);
    // }
    setExpanded(expanded ? false : true);
  };

  let membershipLimit = 5

  return (
    <>
      <ElementScroll name="sitesForm">
        <div className={'site'}>
          <CardProfile
            title={role === 'lawFirm' ? 'Sedes' : 'Sede'}
            subTitle={ role === 'lawFirm' ?
              'Puedes ingresar la ubicación de los centros de trabajo del despacho.' :
              'Puedes ingresar la ubicación de tu centro de trabajo.'
            }
            awardIcon
            status={authClient && authClient.awardPerfil.site ? authClient.awardPerfil.site : false}
          >
            {/* prop edit le indica que lleva el icono de editar*/}

            {(role === "lawyer" && (sede && sede.length === 0)) || !sede || (role === "lawFirm" && sede.length < membershipLimit) ?
              (
                <ExpansionPanel expanded={expanded} >
                  <ExpansionPanelSummary >
                    <div className={classes.expandButton} onClick={handleChange}>
                      <img className="plus" src="/img/profile/plus.svg" alt="" />
                      <p id="t1" style={{ margin: 0 }}>
                        Agregar sede
                    </p>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <AddSite 
                      evento={changeStatus} 
                      arrSedeAll={sede}  
                      handleOpenTrophieModal={handleOpenTrophieModal}
                    />
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ) :
              (<div className={classes.expandButton} style={{opacity: '61%', cursor: 'not-allowed'}}>
                <img className="plus" src="/img/profile/plus.svg" alt="" />
                <p id="t1" style={{ margin: 0 }}>
                  Agregar sede
              </p>
              </div>)
            }


            {sede && sede.length > 0 ? (sede.map((item, index) => (

              <Location key={index} elements={item} id={index} edit={1} arrSedeAll={sede} />
            
            ))) : (null)}

          </CardProfile>


        </div>

      </ElementScroll>

      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title={authClient.role === 'lawFirm' ?
          'Sedes' :
          'Sede'
        }
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Agregar la ubicación de tu centro de trabajo es 
        importante para que los clientes te reconozcan'
      />

    </>

  );
};

const mapDispatchToProps = dispatch => ({
  openModalFree: (state, membership, role) => dispatch(openModalFree(state, membership, role))
})

const mapStateToProps = state => ({
  sede: state.authClient.sede,
  authClient: state.authClient,
  trophie: state.authClient.awardPerfil.site,
  membershipType: state.authClient.membership.type,
});

export default connect(mapStateToProps, mapDispatchToProps)(Site);
